<template>
    <el-row :gutter="20" class="main_block">
        <div class="mianContent">
            <div class="wrap">
                <div class="content">
                    <h5 class="page-title">
                        <span class="blue title-line"></span> 认证结果
                    </h5>
                    <div class="main-box" style="padding-top:20px">
                        <div class="section">
                            <el-steps :active="active" simple class="my-steps">
                                <el-step title="填写信息" style="width:238px">
                                    <img
                                        class="stepsIcon"
                                        src="@/assets/images/steps2-2.png"
                                        alt=""
                                        slot="icon"
                                    />
                                </el-step>
                                <el-step
                                    title="资料已提交，等待审核"
                                >
                                    <img
                                        class="stepsIcon"
                                        src="@/assets/images/steps1-1.png"
                                        alt=""
                                        slot="icon"
                                    />
                                </el-step>

                                <el-step title="审核完成">
                                    <img
                                        class="stepsIcon"
                                        src="@/assets/images/steps3-3.png"
                                        alt=""
                                        slot="icon"
                                        v-if="active==2"
                                    />
                                    <img
                                        class="stepsIcon"
                                        src="@/assets/images/steps3.png"
                                        alt=""
                                        slot="icon"
                                        v-else
                                    />
                                </el-step>
                            </el-steps>
                        </div>
                        <div class="cnt">
                            <div class="parpers_cnt">
                                <div class="info_top">
                                    <p class="ico-wrap">
                                        <img
                                            src="@/assets/images/checktj.png"
                                            alt=""
                                        />
                                        <strong class="shz">基础信息审核中</strong>
                                    </p>
                                    <p class="gz" >
                                        <!-- <span class="font-nowrap">
                                            您的实名认证资料已提交完成，请使用{{
                                                name
                                            }}的{{ bankName }}账户（尾号为{{
                                                banknum
                                            }}）向以下收款账户转账0.01元。
                                        </span>
                                        <br />
                                        <strong style="color:#000; font-weight:600">打款时备注：该款项金额用于联合信任实名认证 。</strong>
                                        实名认证的转账金额，将在转账完成后的次月前两周退回到您转账的账户中。 -->
                                        您的基础信息资料已提交完成，将在1~3个工作日完成审核，请耐心等待。
                                    </p>
                                    <!-- <p class="bold">您的实名认证资料已提交完成，请使用对公账户向以下账户打款完成验证</p>
                            <p class="thin">完成打款后，请耐心等待审核结果（审核时间以银行到账时间为准，一般1~3个工作日）</p> -->
                                </div>
                                <!-- <div class="table">
                                    <dl>
                                        <dt>收款方开户行</dt>
                                        <dd>中国工商银行北京官园支行</dd>
                                    </dl>
                                    <dl>
                                        <dt>收款方账户名称</dt>
                                        <dd>北京联合信任技术服务有限公司</dd>
                                    </dl>
                                    <dl>
                                        <dt>收款方账号</dt>
                                        <dd>0200 0982 1900 6837 964</dd>
                                    </dl>
                                </div>
                                <div class="wait">
                                    <p style="color:#666">
                                        完成打款后，请耐心等待审核结果（审核时间以银行到账时间为准，一般1~3个工作日）
                                    </p>
                                </div> -->
                                <div class="submit">
                                    <!-- <span @click="know()">我知道了</span> -->
                                    <!-- <b @click="cancel(1)">取消认证</b> -->
                                    <a class="cancel" @click="cancel()">取消认证</a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </el-row>
</template>
<script>
import { identification } from "@http/user_center/userInfo";
import {cancel} from '@http/user_center/realName'

export default {
    components: {},
    data() {
        return {
            type: '',
            authenticationStatus: '',
            reason:'',
            active:2,
            name: "",
            bankName: "",
            bankNo: "",
            sourceType:""
        };
    },
    created() {
        let that = this;
        identification().then((res) => {
            console.log(res);
            const { name, bankName, bankNo,sourceType} = res.enterprise;
            that.name = name;
            that.bankName = bankName;
            that.bankNo = bankNo;
            that.sourceType=sourceType;
            that.authenticationStatus = res.authenticationStatus;
            that.type = res.type;
            if(res.authenticationStatus!==3){
                this.$router.push({
                    path: "/userCenter/AuthenticationName",
                });
            }
        }).catch((err) => {
            console.log(err);
        });
    },
    mounted() {},
    computed: {
        banknum() {
            return this.bankNo.slice(-4);
        },
    },
    methods: {
        know() {
            this.$router.push({
                path: "/userCenter/AuthenticationName",
            });
        },
        cancel() {
            let that = this;
            this.$TsaWebTrace.post({
                data: {
                    "eventId": 35017,
                },
            });
            cancel().then((res) => {
                console.log(res);
                this.$msg("取消认证成功", "success");
                setTimeout(function() {
                    that.$router.replace({
                        path: "/userCenter/AuthenticationName",
                    });
                }, 3000);
            }).catch((err) => {
                // this.$msg(err.message);
                console.log(err);
            });
        },
    },
};
</script>
<style src="../../assets/css/content.css" scoped></style>
<style scoped>
.main-box {
    width: 940px;
    margin: 0 auto;
}
.cnt {
    text-align: center;
}
.parpers_cnt {
    text-align: center;
    width: 100%;
    background: #fff;
    padding: 1px 31px;
    margin-top: 24px;
    box-sizing: border-box;
}
.ico-wrap {
    margin-bottom: 30px;
}

.submit {
    margin-top: 32px;
    text-align: center;
}
.submit span {
    display: inline-block;
    text-align: center;
    width: 148px;
    height: 40px;
    line-height: 40px;
    color: #3080fe;
    cursor: pointer;
    border-radius: 4px;
    font-size: 14px;
    border: 1px solid #3080fe;
}
.submit b {
    margin-left: 30px;
    display: inline-block;
    text-align: center;
    width: 148px;
    height: 40px;
    line-height: 40px;
    color: #999;
    cursor: pointer;
    border-radius: 4px;
    font-size: 14px;
    border: 1px solid #ccc;
}
.submit b:hover {
    color: #333;
    background: #f5f5f5;
}
.submit span:hover {
    background: #3080fe;
    color: #fff;
}
.bold {
    color: #333;
    font-size: 18px;
    font-weight: 400;
    margin-bottom: 15px;
}
.thin {
    font-size: 14px;
    color: #999;
}
.table {
    width: 100%;
    margin-top: 29px;
    box-sizing: border-box;
    padding: 10px 20%;
    background: #fafafa;
    border: 1px solid #e1e6eb;
}
.table dl {
    overflow: hidden;
    border-bottom: 1px dashed #e1e6eb;
    padding: 20px 0 20px;
    font-size: 14px;
    color: #333;
}
.table dl:last-child {
    border: none;
}
.table dt {
    float: left;
}
.table dd {
    float: right;
}
.btns {
    width: 100px;
    padding-top: 14px;
}
.goback {
    display: inline-block;
    width: 94px;
    height: 28px;
    font-size: 14px;
    border-radius: 28px;
    cursor: pointer;
    line-height: 28px;
    background: #fff;
    color: #333;
    border: 1px solid #3080fe;
    margin-top: 12px;
}
.parpers_cnt p{
  margin: 1px 0 20px;
  font-size: 14px;
  color:#333;
}
.parpers_cnt .gz {
    font-size: 14px;
    line-height: 28px;
    font-weight: 500;
    color: #333;
    width: 1400px;
    margin-left: -261px;
}
.wait {
    color: #666;
    text-align: center;
    font-size: 15px;
    margin: 38px 0 40px;
}
.shz{
    display: block;
    font-weight: 600;
    font-size: 16px;
    margin-top: 20px !important;
}

.reasons{
  font-size: 14px;
  color:#666;
}
.goattestation span{
  margin-top: 20px;
  display: inline-block;
  width: 110px;
  height: 33px;
  line-height: 33px;
  border: 1px solid #3F7DF7;
  color:#3F7DF7;
  border-radius: 33px;
  cursor: pointer;
}
.goattestation span:hover{
  color:#fff;
  background:#3F7DF7;
}
.font-nowrap{
    white-space: nowrap;
}
.cancel{
    color:#3f7df7;
    cursor: pointer;
}
.cancel:hover{
    color:#79a9f8;
}
</style>
<style lang="less">
.my-steps .el-step__icon.is-text {
    border: none;
}
.my-steps .el-step.is-simple .el-step__icon {
     width: 65px;

    height: 44px;
    img {
        width: 44px;
        height: 44px;
    }
}
.my-steps .el-step__icon {
    border: none;
}
.my-steps .el-step.is-simple .el-step__head {
    padding: 0;
}
.my-steps .stepsIcon {
    margin-right: 10px;
}
.my-steps {
    background: #fff;
    padding: 13px 5%;
}
.el-step__title.is-finish {
    font-weight: 500;
}
</style>
